// extracted by mini-css-extract-plugin
module.exports = {"keyboardGrid":"ExtendedKeyboard_keyboardGrid__3RmUk"};